import axios from "axios";
import { axiosWithKey } from '~/axios'
import { getToken} from '~/redux/user/tokens'


export function getEmailExists(email) {
  
  return getToken().then(token => {
     return axiosWithKey.post('/identity/email',
          {
            email: email,
          	headers:{
            		Authorization: token
          	}
        })
        .then(response => {
        	return response.data.email != undefined;
        })
        .catch(error => {
        	if(error.response.status === 404){
        		return false;
        	}else{
        		console.log('There was an error finding this email: ' + email)
        		console.log(error);
        	}
        });
  });
} 